import {MonitorConfig} from './VideoStreamMonitor';
import {TaskInfo} from '../../../types/metadata/TaskInfo';

export enum EVENT_TYPE {
  READY_TO_START = 'READY_TO_START',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  CONNECTION_FAILED = 'CONNECTION_FAILED',
  ERROR = 'ERROR',
  REMOTE_STREAM = 'REMOTE_STREAM',
  DATA = 'DATA',
  STREAM_FINISHED = 'STREAM_FINISHED',
}

export enum ERROR_TYPE {
  INITIALIZATION = 'INITIALIZATION',
  CONNECTION_TERMINATED = 'CONNECTION_TERMINATED',
}

export type VideoStreamEvent = {
  type: EVENT_TYPE;
  error?: ERROR_TYPE;
  message?: string | null;
  monitorConfig?: MonitorConfig;
  data?: Record<string, any>;
  taskInfo?: TaskInfo;
  deploymentId?: string;
  subject?: VideoStreamSubject;
};

export class VideoStreamSubject {
  order: string[] = [];
  handlers: Map<string, VideoStreamObserver> = new Map<string, VideoStreamObserver>();

  hasListeners() {
    return this.order.length > 0;
  }

  addListener(name: string, listener: VideoStreamObserver) {
    if (!this.handlers.has(name)) {
      this.order.unshift(name);
    }
    this.handlers.set(name, listener);
  }

  removeListener(name: string) {
    if (this.handlers.has(name)) {
      this.order = this.order.filter(n => {
        return n !== name;
      });
      this.handlers.delete(name);
    }
  }

  raiseReadyToStartEvent(taskInfo: TaskInfo) {
    this.notify({
      type: EVENT_TYPE.READY_TO_START,
      taskInfo,
    });
  }

  raiseConnectingEvent() {
    this.notify({
      type: EVENT_TYPE.CONNECTING,
    });
  }

  raiseInitErrorEvent(message?: string | null) {
    this.notify({
      type: EVENT_TYPE.ERROR,
      error: ERROR_TYPE.INITIALIZATION,
      message,
    });
  }

  raiseConnectionTerminationEvent(message?: string | null) {
    this.notify({
      type: EVENT_TYPE.ERROR,
      error: ERROR_TYPE.CONNECTION_TERMINATED,
      message,
    });
  }

  raiseStreamFinishEvent() {
    this.notify({
      type: EVENT_TYPE.STREAM_FINISHED,
    });
  }

  raiseDataEvent(data: any) {
    this.notify({
      type: EVENT_TYPE.DATA,
      data,
    });
  }

  raiseStreamReadyEvent() {
    this.notify({
      type: EVENT_TYPE.REMOTE_STREAM,
    });
  }

  raiseConnectedEvent() {
    this.notify({
      type: EVENT_TYPE.CONNECTED,
    });
  }

  raiseConnectionFailedEvent() {
    this.notify({
      type: EVENT_TYPE.CONNECTION_FAILED,
    });
  }

  private notify(event: VideoStreamEvent) {
    event.subject = this;
    this.order
      .map(name => this.handlers.get(name))
      .forEach(observer => {
        if (observer) {
          observer.handleEvent(event);
        }
      });
  }
}

export class VideoStreamObserver {
  handleEvent(event: VideoStreamEvent) {}
}
